import { render, staticRenderFns } from "./ModalNotes.vue?vue&type=template&id=4803d96c&scoped=true&"
import script from "./ModalNotes.vue?vue&type=script&lang=js&"
export * from "./ModalNotes.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotes.vue?vue&type=style&index=0&id=4803d96c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803d96c",
  null
  
)

export default component.exports